import { render, staticRenderFns } from "./ProfileOverview2.vue?vue&type=template&id=1642118a&"
import script from "./ProfileOverview2.vue?vue&type=script&lang=js&"
export * from "./ProfileOverview2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports